import { Download, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAtributoDownload } from '@/hooks/useAtributoDownload';
import { sanitizeFilename } from '@/lib/utils';

interface Props {
  cdAtendimento: number;
  cdValor: number;
  dsAtributo?: string;
}

export function AtributoDownloadButton({
  cdAtendimento,
  cdValor,
  dsAtributo,
}: Props) {
  const { download, isDownloading, error } = useAtributoDownload(
    cdAtendimento,
    cdValor,
  );

  const filename = `atendimento_${cdAtendimento}_${sanitizeFilename(
    dsAtributo || 'documento',
  )}.rtf`;

  return (
    <div className="flex flex-col items-end gap-1">
      <Button
        variant="default"
        size="sm"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          download(filename);
        }}
        disabled={isDownloading}
        aria-label={`Baixar ${dsAtributo || 'documento'}`}
      >
        {isDownloading ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <Download className="h-4 w-4" />
        )}
        <span className="ml-2 hidden sm:inline">Baixar .rtf</span>
      </Button>
      {error && (
        <span className="text-xs text-destructive" role="alert">
          {error.message}
        </span>
      )}
    </div>
  );
}
